export default {
  methods: {
    updateField(e, mutation, field) {
      this.$store.commit(mutation, e.target.value)
      this.$store.commit('forms/removeServerErrors', field)
    },
  },
}
